var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconCommentary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8737 8.00004C6.8737 7.37872 7.37738 6.87504 7.9987 6.87504H16.1654C16.7867 6.87504 17.2904 7.37872 17.2904 8.00004V16.1667C17.2904 16.788 16.7867 17.2917 16.1654 17.2917H7.9987C7.37738 17.2917 6.8737 16.788 6.8737 16.1667V8.00004ZM8.1237 8.12504V16.0417H16.0404V8.12504H8.1237Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70703 3.83337C2.70703 3.21205 3.21071 2.70837 3.83203 2.70837H11.9987C12.62 2.70837 13.1237 3.21205 13.1237 3.83337V7.50004C13.1237 7.84522 12.8439 8.12504 12.4987 8.12504C12.1535 8.12504 11.8737 7.84522 11.8737 7.50004V3.95837H3.95703V11.875H7.4987C7.84388 11.875 8.1237 12.1549 8.1237 12.5C8.1237 12.8452 7.84388 13.125 7.4987 13.125H3.83203C3.21071 13.125 2.70703 12.6214 2.70703 12V3.83337Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconCommentary);
export default __webpack_public_path__ + "static/media/copy-icon-commentary.abce5df8b0cd780f5aca05f5bfd296ff.svg";
export { ForwardRef as ReactComponent };